import classnames from 'classnames';
import { FocusEventHandler } from 'react';

import type { IWithLabelProps } from '../WithLabel/WithLabel';
import { WithLabel } from '../WithLabel/WithLabel';

export interface ISwitchProps {
  id: string;
  isDisabled?: boolean;
  label?: string;
  className?: string;
  labelClassName?: string;
  value: boolean;
  isAlignedLeft?: boolean;
  tooltip?: string;
  tabIndex?: number;
  e2e?: string;
  onToggleSwitch?(value: boolean): void;

  size?: 'md' | 'sm';
  onBlur?: FocusEventHandler<HTMLInputElement>;

  useEditedStyle?: boolean;
}

export function Switch({ size = 'sm', useEditedStyle = true, ...props }: ISwitchProps) {
  function handleClick() {
    if (!props.isDisabled) {
      props.onToggleSwitch?.(!props.value);
    }
  }

  return (
    <div
      data-e2e="switch-container"
      className={classnames(`form-check form-check-${size} form-switch`, props.className, {
        'text-info': props.isDisabled,
        'form-check-edited': useEditedStyle,
      })}
    >
      <input
        checked={props.value}
        className="form-check-input cursor-pointer"
        disabled={props.isDisabled}
        id={props.id}
        data-e2e={props.e2e ? `${props.e2e}-input` : undefined}
        name={props.id}
        tabIndex={props.tabIndex}
        onChange={handleClick}
        onBlur={props.onBlur}
        type="checkbox"
      />
      {props.label && (
        <label
          className={classnames('form-check-label', props.labelClassName)}
          htmlFor={props.id}
          onClick={handleClick}
        >
          {props.label}
        </label>
      )}
    </div>
  );
}

type SwitchWithLabelProps = Omit<ISwitchProps, 'className'> & IWithLabelProps & { switchClassName?: string };
export function SwitchWithLabel({
  label,
  className,
  wrapText,
  colSize,
  icon,
  switchClassName,
  ...switchProps
}: SwitchWithLabelProps) {
  return (
    <WithLabel
      colSize={colSize}
      id={switchProps.id}
      label={label}
      isAlignedLeft={switchProps.isAlignedLeft}
      className={className}
      wrapText={wrapText}
      tooltip={switchProps.tooltip}
      icon={icon}
    >
      <Switch className={switchClassName} {...switchProps} />
    </WithLabel>
  );
}
